import { BaseModel } from "./base.model";
import { BlocoAssinatura } from "./bloco-assinatura.model";
import { TipoDocumento } from "./tipo-documento.model";

export class Signatario {
    id?: number;
    nomeUsuario: string;
    codigoUsuario: string;
    obrigatorio: boolean;
    emailEnvio: string;
    /**
     * CPF do convidado externo ja gravado, como o servidor devolve: mascarado (***.848.331-**).
     * So para exibir — o campo editavel (cpf) nasce vazio, e em branco o servidor preserva o
     * que ja esta gravado.
     */
    cpfGravado?: string;
    assinaturasDocumento?: {
        id: number
    }[];
    recusa?: {
        id: number;
        complemento?: string;
        dataRecusa?: string;
        motivo?: {
            id: number;
            descricaoMotivoRecusa: string;
            statusMotivoRecusa: string;
        };
    };
    status?: string;
    cpf?: string;
}

export interface CancelamentoDocumento {
    motivo: { id: number; descricaoMotivoRecusa: string };
    descricao: string;
    dataCancelamento: string;
    codigoUsuario: string;
    nomeUsuario: string;
}

export class Documento extends BaseModel {
    id: number;
    nome: string;
    descricao?: string;
    cancelamento?: CancelamentoDocumento;
    status: string;
    signatarios: Signatario[];
    tipoDocumento: TipoDocumento;
    blocoAssinatura: BlocoAssinatura;
    dataArquivo: string;
    dataUltimaModificacao: string;
    urlDocumento: string;
    dataVigencia: string;
    indiPermiteAssinador: string;
    codigoUsuarioProprietario: string;
    emailUsuarioProprietario: string;

    constructor(obj: any) {
        super();
        this.assign(obj);
    }

    protected assign(obj: any) {
        Object.assign(this as any, obj);
        this.originalState = { ...this };
    }

    static override fromJson(json: any): Documento {
        if (json === undefined || json === null) {
            return null;
        }
        return new Documento(json);
    }
}

/**
 * Dono do documento: decidido pelo codigo do usuario, a mesma chave que o servidor usa em
 * validarPermissaoEdicao. Fica aqui, e nao nos componentes, para a lista e a modal nunca
 * divergirem sobre quem pode editar. Funcao solta porque o documento chega como JSON puro.
 */
export function documentoPertenceA(
  documento: { codigoUsuarioProprietario?: string } | null | undefined,
  codigoUsuario: string | null | undefined): boolean {
  const proprietario = documento?.codigoUsuarioProprietario;
  return !!proprietario && proprietario === codigoUsuario;
}
